import React from "react"
import clsx from "clsx"

function PseudoBackground({ category }) {
  return (
    <div className="absolute top-0 bottom-0 left-0 right-0 flex flex-col w-full h-full">
      <div className="wrapper default-grid">
        <div
          className={clsx(
            "col-span-full",
            category?.slug === "/"
              ? "md:col-span-6 lg:col-span-4 xl:col-span-3"
              : "sm:col-span-6"
          )}
        >
          <div
            className={
              category?.slug === "/"
                ? "aspect-w-5 aspect-h-4 md:aspect-w-4 md:aspect-h-3"
                : "aspect-w-5 aspect-h-4 md:aspect-w-8 md:aspect-h-5"
            }
          />
        </div>
      </div>
      <div className="relative flex-1">
        <div className="absolute top-0 bottom-0 w-screen h-full transform -translate-x-1/2 bg-lightBlue left-1/2" />
      </div>
    </div>
  )
}

export default PseudoBackground
